import { TEXT_FILE_DISPLAY_MAX_SIZE } from "~/constants";
import { fileTransferConfig } from "~/resource/data-source/file-transfer-config";
import { modelTypes } from "~/utils";

import { FileType } from "./get-file-type";

export type FileStatus = "ready" | "not_previewable" | "unsupported" | "unimplemented" | "too_large" | "loading";

export const getFileStatus = (
  type: FileType,
  contentSize: number | null | undefined,
  extension?: string,
): FileStatus => {
  if (contentSize == null) return "loading";
  if (!Number.isSafeInteger(contentSize) || contentSize < 0 || contentSize > fileTransferConfig.previewMaxBytes) {
    return "too_large";
  }

  const normalizedExtension = extension?.toLowerCase();
  const modelConfig = normalizedExtension ? modelTypes[normalizedExtension as keyof typeof modelTypes] : null;

  // `modelTypes` is keyed by extension, so it has nothing to say about a file that states none.
  // Those are resolved by name instead -- `data.json`, `README.md` -- and the resolved type is
  // then the only thing that can answer whether there is a viewer for it.
  if (normalizedExtension ? !modelConfig?.previewable : type === "file") return "not_previewable";

  if (type === "file") return "not_previewable";

  if (!PREVIEWABLE_FILE_TYPES.has(type)) return "unsupported";

  if (SIZE_CAPPED_TEXT_FILE_TYPES.has(type) && contentSize > TEXT_FILE_DISPLAY_MAX_SIZE) return "too_large";

  return "ready";
};

const PREVIEWABLE_FILE_TYPES: ReadonlySet<FileType> = new Set([
  "image",
  "text",
  "pdf",
  "docx",
  "3dviewer",
  "html",
  "markdown",
  "xml",
  "json",
  "csv",
]);

const SIZE_CAPPED_TEXT_FILE_TYPES: ReadonlySet<FileType> = new Set(["text", "xml", "json", "csv"]);
